module.exports = __webpack_public_path__ + "img/loading.f1daadab.gif";